import { useEffect, useState } from 'react';
import { callApi } from '../api';
import { Section, Stat, ErrorBox, LoadingSpinner } from '../components/Section';
import { Sparkline } from '../components/Sparkline';
import { useSession } from '../hooks/useSession';

export function Overview() {
  const { session, counts } = useSession();
  const [series, setSeries] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    callApi('/api/v1/admin/users/active-counts?days=30', {
      accessToken: session.access_token,
    })
      .then(setSeries)
      .catch((e) => setError(e.message));
  }, [session.access_token]);

  if (error) return <ErrorBox message={error} />;
  if (!series || !counts || Object.keys(counts).length === 0) return <LoadingSpinner />;

  const today = series.rows[series.rows.length - 1] || {};

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-stone-800">Overview</h1>

      <Section title="At a glance">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <Stat value={counts.open_feedback_count} label="open feedback" />
          <Stat value={counts.waitlist_pending_count} label="waitlist pending" />
          <Stat value={counts.beli_queue_pending_count} label="beli queue" />
          <Stat value={counts.dau_24h} label="DAU (24h)" />
        </div>
      </Section>

      <Section title="Active users (last 30 days)">
        <Sparkline rows={series.rows} height={80} />
        <div className="grid grid-cols-3 gap-4 mt-4">
          <Stat value={today.dau ?? 0} label="DAU today" />
          <Stat value={today.wau ?? 0} label="WAU" />
          <Stat value={today.mau ?? 0} label="MAU" />
        </div>
      </Section>

      <Section title="System">
        <div className="grid grid-cols-3 gap-4">
          <Stat value={counts.dead_beli_accounts} label="dead beli accts" />
          <Stat value={counts.haiku_calls_today} label="Haiku calls today" />
          <Stat value={counts.embedding_calls_today} label="embed calls today" />
        </div>
      </Section>
    </div>
  );
}
